document.addEventListener("DOMContentLoaded", function(){
    // console.log("Custom JS loaded");
});

/********** Cookies **********/
function setCookie(name,value,expireHours) {
  let d = new Date();
  d.setTime(d.getTime() + (expireHours*60*60*1000));
  document.cookie = name + "=" + value + ";" + "expires=" + d.toUTCString() + ";path=/";
}
function getCookie(name) {
  function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
  let match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
  return match ? match[1] : null;
}
function removeCookie(name) {
    document.cookie = name + "=;Max-Age=-99999999;path=/";
}


/********** PDP – Sales Badge **********/
(function () {
  var el = document.querySelector('.pdp-sales__count');
  if (!el) return;

  // If metafield is explicitly set to -1, hide the badge entirely
  if (el.dataset.sales === '-1') {
    var badge = el.closest('.pdp-sales');
    if (badge) badge.style.display = 'none';
    return;
  }

  var productId = el.dataset.productId;
  var cookieName = 'pdp_sales_' + productId;
  var cached = getCookie(cookieName);
  var count;
  if (cached) {
    count = parseInt(cached, 10);
  } else {
    var metaValue = parseInt(el.dataset.sales, 10);
    if (metaValue > 0) {
      var variance = metaValue * 0.15;  // +- 15%
      count = Math.round(metaValue - variance + Math.random() * variance * 2);
    } else {
      count = Math.floor(Math.random() * 56) + 10;
    }
    count = Math.max(0, count);
    setCookie(cookieName, count, 1);
  }
  el.textContent = count;
})();


/********** Add to Cart – Custom Product Card **********/
function customCardAddToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('loading');
    btn.textContent = 'Adding…';

    const cartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) {
        return res.json().then(function(data) {
            if (!res.ok || data.status) {
                throw new Error(data.description || data.message || 'Add to cart failed');
            }
            return data;
        });
    })
    .then(function() {
        return fetch('/cart.js').then(function(res) { return res.json(); });
    })
    .then(function(cart) {
        btn.textContent = 'Added!';
        btn.style.backgroundColor = 'var(--color-black)';

        document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
                resource: cart,
                sourceId: 'custom-product-card',
                data: {
                    source: 'custom-product-card',
                    itemCount: cart.item_count,
                    variantId: String(variantId)
                }
            }
        }));

        setTimeout(function() {
            btn.textContent = 'Add to Cart';
            btn.style.backgroundColor = '';
            btn.classList.remove('loading');
        }, 1800);
    })
    .catch(function() {
        btn.textContent = 'Error – Try again';
        btn.style.backgroundColor = 'var(--color-red)';
        btn.classList.remove('loading');
        setTimeout(function() {
            btn.textContent = 'Add to Cart';
            btn.style.backgroundColor = '';
        }, 2000);
    });
}


/********** On Resize **********/
window.addEventListener('resize', function(event) {
    
});


/********** Home Collection List Swiper **********/
(function() {
    const swiperContainer = document.querySelector('.home-collection-list__swiper');
    if(swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 15,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                750: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 4,
                }
            }
        });
    }
})();

/********** Article table of contents (built from H2 headings) **********/
(function () {
    function buildArticleToc() {
        var toc = document.querySelector('[data-article-toc]');
        var content = document.querySelector('[data-article-content]');
        if (!toc || !content) return;

        var list = toc.querySelector('.article__toc-list');
        var headings = content.querySelectorAll('h2');
        if (!list || headings.length < 3) return;

        list.innerHTML = '';
        var used = {};
        headings.forEach(function (heading, index) {
            var text = heading.textContent.replace(/\s+/g, ' ').trim();
            if (!text) return;

            var id = heading.id;
            if (!id) {
                id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section-' + (index + 1);
                if (used[id]) id = id + '-' + (index + 1);
                heading.id = id;
            }
            used[id] = true;

            var item = document.createElement('li');
            var link = document.createElement('a');
            link.href = '#' + id;
            link.textContent = text;
            item.appendChild(link);
            list.appendChild(item);
        });

        if (list.children.length) toc.hidden = false;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', buildArticleToc);
    } else {
        buildArticleToc();
    }
    document.addEventListener('shopify:section:load', buildArticleToc);
})();

(function () {
  var btn = document.createElement('button');
  btn.className = 'scroll-to-top';
  btn.setAttribute('aria-label', 'Scroll to top');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';
  document.body.appendChild(btn);
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.__scrollToTopBtn = btn;
})();


/********** On Scroll **********/
window.addEventListener('scroll', function(event) {
    var bodyScroll = Math.abs( document.body.getBoundingClientRect().top );
    if ( bodyScroll > 300 ) {
        document.querySelector('.header-logo__image').classList.add('is-scrolled');
        if (window.__scrollToTopBtn) window.__scrollToTopBtn.classList.add('is-visible');
    } else {
        document.querySelector('.header-logo__image').classList.remove('is-scrolled');
        if (window.__scrollToTopBtn) window.__scrollToTopBtn.classList.remove('is-visible');
    }
});